module.exports = __webpack_public_path__ + "static/media/alert.36ee9ee7.svg";